{
  "common": {
    "saveAndOpen": "Speichern & Öffnen",
    "confirm": "Bestätigen",
    "reset": "Zurücksetzen",
    "add": "Hinzufügen",
    "edit": "Bearbeiten",
    "delete": "Löschen",
    "remove": "Entfernen",
    "enable": "Aktivieren",
    "disable": "Deaktivieren",
    "enabled": "aktiviert",
    "disabled": "deaktiviert",
    "deleteEntries": "{count} Eintrag löschen | {count} Einträge löschen",
    "enableEntries": "{count} Eintrag aktivieren | {count} Einträge aktivieren",
    "disableEntries": "{count} Eintrag deaktivieren | {count} Einträge deaktivieren",
    "description": "Beschreibung",
    "employees": "Mitarbeiter",
    "name": "Name",
    "email": "E-Mail",
    "firstName": "Vorname",
    "lastName": "Nachname",
    "company": "Unternehmen",
    "status": "Status",
    "details": "Details",
    "userStatus": {
      "invited": "Eingeladen",
      "active": "Aktiv",
      "expired": "Einladung abgelaufen"
    },
    "type": "Typ",
    "createdAtDate": "Erstellt am",
    "refresh": "Aktualisieren",
    "id": "Id",
    "or": "oder",
    "and": "und",
    "skills": "Skills",
    "role": "Rolle",
    "target": "Ziel",
    "targets": "Ziele",
    "assignedUsers": "Zugewiesene Benutzer",
    "assignedTargets": "Zugewiesene @:common.targets",
    "baseData": "Basisdaten",
    "noUsersFound": "Keine Benutzer gefunden...",
    "noUsersAssigned": "Keine Benutzer zugewiesen...",
    "selectUsers": "Benutzer auswählen",
    "usersSelected": "{count} Benutzer ausgewählt",
    "notAddressed": "Keine Ansprache",
    "learnMore": "Mehr erfahren",
    "date": "Datum",
    "dateRange": "Zeitraum",
    "noEntries": "Keine Einträge",
    "noEntriesYet": "Es sind noch keine Einträge vorhanden.",
    "showDisabled": "Deaktivierte anzeigen",
    "disabledToggleTooltip": "Auswahl aufheben, um Funktion zu aktivieren",
    "channel": "Kanal",
    "export": "Exportieren",
    "fields": "Eingabefelder",
    "requiredField": "Pflichtfeld",
    "support": "Support",
    "from": "Von",
    "to": "Bis",
    "deletedUser": "Gelöschter Benutzer",
    "import": "Importieren",
    "title": "Titel",
    "view": "Anzeigen",
    "download": "Herunterladen",
    "sidebar": "Sidebar"
  },
  "misc": {
    "confirmation": {
      "dialogTitle": "Bestätigung",
      "enable": "Sollen die ausgewählten Einträge wirklich aktiviert werden?",
      "disable": "Sollen die ausgewählten Einträge wirklich deaktiviert werden?",
      "delete": "Sollen die ausgewählten Einträge wirklich gelöscht werden?",
      "deleteSingle": "Soll der Eintrag wirklich gelöscht werden?",
      "cancelImportJob": "Soll der Import wirklich abgebrochen werden?"
    },
    "operatorOptions": {
      "greater_than": "größer als",
      "lower_than": "kleiner als",
      "within_range": "zwischen",
      "equal": "gleich",
      "unequal": "ungleich",
      "contains": "beinhaltet",
      "not_contains": "beinhaltet nicht",
      "starts_with": "fängt an mit",
      "in": "in Liste enthalten",
      "date_equal": "gleich",
      "date_before": "vor (Datum)",
      "date_after": "nach (Datum)",
      "date_before_field": "vor (Feld)",
      "date_after_field": "nach (Feld)",
      "date_before_summary": "vor",
      "date_after_summary": "nach",
      "date_in_future": "in der Zukunft",
      "date_in_past": "in der Vergangenheit",
      "date_between": "zwischen",
      "date_within_last": "innerhalb der letzten",
      "date_not_within_last": "nicht innerhalb der letzten",
      "date_within_next": "innerhalb der nächsten",
      "date_not_within_next": "nicht innerhalb der nächsten",
      "is_null": "ist leer",
      "is_not_null": "ist nicht leer"
    },
    "timeUnits": {
      "days": "Tage",
      "weeks": "Wochen",
      "months": "Monate",
      "years": "Jahre"
    },
    "reportingLevel": {
      "TEAM": "Team",
      "USER": "User"
    },
    "datePresets": {
      "today": "Heute",
      "lastWeek": "Letzte Woche",
      "currentMonth": "Aktueller Monat",
      "lastMonth": "Letzer Monat"
    }
  },
  "components": {
    "filter": {
      "reset": "Filter zurücksetzen",
      "apply": "Filter anwenden",
      "all": "Alle",
      "selectedMultiple": "Elemente ausgewählt",
      "submittersSelected": "{count} Erfasser ausgewählt",
      "labels": {
        "targetType": "Zieltyp",
        "submitter": "Erfasser"
      }
    },
    "input": {
      "options": "{n} Optionen",
      "enterValue": "Wert eingeben",
      "enterNumber": "Zahl eingeben",
      "deletedTreeOption": "Dieser Wert existiert nicht mehr und kann daher nicht ausgewählt werden.",
      "fileUpload": {
        "empty": "CSV-Datei hierher ziehen oder {browse}",
        "browse": "durchsuchen",
        "chooseOtherFile": "Andere Datei wählen",
        "clearFile": "Datei entfernen"
      }
    },
    "catalog": {
      "customerImport": {
        "title": "Datensätze importieren",
        "selectFiles": {
          "description": "Im ersten Schritt müssen die Kunden- und Vertragsdaten im CSV-Format hochgeladen werden.",
          "requiredFields": "Pflichtfelder",
          "documentationLink": "Dokumentation",
          "warning": "Durch den Import werden alle bestehenden Datensätze überschrieben. Vertragsdaten werden nur hinzugefügt, wenn eine passende Kunden-ID in beiden Dateien vorhanden ist.",
          "customersFile": "Kundendaten",
          "contractsFile": "Vertragsdaten"
        },
        "configuration": "Trennzeichen und Zeichenkodierung festlegen.",
        "columnMapping": {
          "description": "Weise die Spalten den Pflichtfeldern zu, um deine Daten vollständig zu importieren.",
          "warning": "Die {fieldName} muss in den Kunden- und Vertragsdaten identisch sein, da sie zur Verknüpfung der Datensätze verwendet wird. Zusätzlich dient die {fieldName} als Standard-Suchfeld in der Sidebar.",
          "requiredFields": "Pflichtfelder",
          "optionalFields": "Optionale Felder"
        },
        "summary": {
          "description": "Überprüfe die erkannten Trennzeichen, Zuordnungen und Dateien, bevor du deine Daten importierst.",
          "warning": "Durch Bestätigen startet der Import im Hintergrund und bestehende Datensätze werden überschrieben."
        },
        "actions": {
          "cancel": "Import abbrechen",
          "startAssistant": "Import-Assistenten starten",
          "backToFileSelection": "Zurück zur Dateiauswahl",
          "toColumnMapping": "Weiter zur Spaltenzuweisung",
          "backToConfiguration": "Zurück zur Konfiguration",
          "toSummary": "Weiter zur Importübersicht",
          "backToChanges": "Änderungen vornehmen",
          "startImport": "Import im Hintergrund starten"
        },
        "detectionLoading": "Dateien werden analysiert…",
        "detectionLoadingLong": "Konfiguration wird ermittelt…",
        "labels": {
          "delimiter": "Trennzeichen",
          "encoding": "Zeichenkodierung",
          "uploadedFiles": "Hochgeladene Dateien",
          "configuration": "Vorgenommene Konfiguration",
          "detected": "Erkannt",
          "columnsAmount": "{count} Spalte | {count} Spalten",
          "fields": {
            "customerId": "Kunden-ID",
            "firstName": "Vorname",
            "lastName": "Nachname",
            "contractId": "Vertrags-ID",
            "city": "Stadt",
            "zipCode": "Postleitzahl",
            "streetName": "Straße",
            "houseNumber": "Hausnummer"
          }
        },
        "placeholders": {
          "selectIdField": "Spalte auswählen",
          "selectEncoding": "Zeichenkodierung auswählen",
          "selectDelimiter": "Trennzeichen auswählen"
        },
        "reviewSettings": "Überprüfe die erkannten Einstellungen und passe sie bei Bedarf an.",
        "headersotherHeaders": "+{n} weitere Header",
        "options": {
          "delimiter": {
            "comma": "Komma",
            "semicolon": "Semikolon"
          },
          "encoding": {
            "utf8": "UTF-8",
            "utf16": "UTF-16",
            "windows1252": "Windows-1252 (Westeuropäisch)",
            "latin1": "Latin-1 (ISO-8859-1)",
            "latin9": "Latin-9 (ISO-8859-15)"
          }
        }
      },
      "notifications": {
        "import": {
          "summary": "Import erfolgreich gestartet",
          "detail": "Der Import wurde erfolgreich gestartet."
        }
      },
      "errors": {
        "importTitle": "Import fehlgeschlagen",
        "importMessage": "Beim Import ist ein Fehler aufgetreten",
        "noFilesSelected": "Keine Dateien ausgewählt",
        "missingSidebarSearchParameterCustomer": "Die Kundendatei muss den konfigurierten Sidebar-Suchparameter \"{fieldName}\" enthalten.",
        "missingSidebarSearchParameterContract": "Die Vertragsdatei muss die Spalte \"{fieldName}\" für den konfigurierten Sidebar-Suchparameter enthalten.",
        "invalidEncoding": "Das Encoding scheint nicht zur Datei zu passen. Import mit dieser Auswahl erfolgt auf eigene Gefahr."
      }
    },
    "userRoleForm": {
      "applications": "Anwendungen",
      "canUseCockpit": "Kann Cockpit nutzen",
      "canUseSidebar": "Kann Sidebar nutzen",
      "canSeeTargets": "Kann @:common.targets sehen",
      "canEditTargets": "Kann @:common.targets bearbeiten",
      "canSeeChannels": "Kann Kanäle sehen",
      "canEditChannels": "Kann Kanäle bearbeiten",
      "canSeeUsers": "Kann Benutzer sehen",
      "canEditUsers": "Kann Benutzer bearbeiten",
      "canSeeUserRoles": "Kann Rollen sehen",
      "canEditUserRoles": "Kann Rollen bearbeiten",
      "canSeeBilling": "Kann Abrechnung sehen",
      "canEditBilling": "Kann Abrechnung bearbeiten",
      "canSeeRules": "Kann Kundenselektion sehen",
      "canEditRules": "Kann Kundenselektion bearbeiten",
      "canSeeCatalog": "Kann Katalog sehen",
      "canEditCatalog": "Kann Katalog bearbeiten",
      "tariffs": "Tarife",
      "canSeeTariffs": "Kann Tarife sehen",
      "canEditTariffs": "Kann Tarife bearbeiten",
      "canEditSettings": "Kann Einstellungen bearbeiten",
      "canSeeDashboard": "Kann Dashboard sehen",
      "canSeeTeamOnlyData": "Kann nur Daten des eigenen Teams sehen",
      "canSeeAnswers": "Kann Antworten sehen",
      "canEditAnswers": "Kann Antworten bearbeiten",
      "canSeeAuditLogs": "Kann Logs sehen",
      "canSeeSsoConfig": "Kann SSO-Konfiguration sehen",
      "canEditSsoConfig": "Kann SSO-Konfiguration bearbeiten"
    },
    "userRoles": {
      "accessCockpit": "Zugang Cockpit",
      "accessSidebar": "Zugang Sidebar",
      "editUserRole": "Rolle bearbeiten",
      "addUserRole": "Rolle hinzufügen",
      "deleteRole": "Rolle löschen",
      "promptRoleDelete": "Soll die Rolle \"{role}\" wirklich gelöscht werden?",
      "roleInUse": "Die Rolle ist noch einem oder mehreren Benutzern zugewiesen."
    },
    "seatWarningDialog": {
      "moreUsersThanSeats": "Mehr Benutzer als Seats",
      "userCountExceedsSeatCount": "Die Anzahl der Benutzer übersteigt die Anzahl der gebuchten Seats.",
      "additionalSeatsRequired": "Es müssen zusätzliche Seats gebucht oder bestehende Benutzer gelöscht werden.",
      "later": "Jetzt nicht",
      "manageUsers": "Benutzer verwalten",
      "manageSeats": "Seats verwalten",
      "understood": "Verstanden",
      "accessRestricted": "Ihr Zugang ist vorübergehend eingeschränkt, bis das Problem behoben wurde."
    },
    "dataTable": {
      "clearFilters": "Alle Filter entfernen"
    },
    "answerTable": {
      "fieldsConfigured": "0 Felder konfiguriert | 1 Feld konfiguriert | {n} Felder konfiguriert",
      "targetsAssigned": "0 Ziele | 1 Ziel | {n} Ziele",
      "usedIn": "Verwendet in",
      "menu": {
        "editAnswer": "Antwort bearbeiten",
        "duplicateAnswer": "Antwort duplizieren",
        "deleteAnswer": "Antwort entfernen"
      }
    },
    "answerTargetsTable": {
      "search": "Nach Ziel suchen"
    },
    "answerForm": {
      "useTargetChannels": "Kanäle aus Ziel übernehmen",
      "fieldsInfo": "Hier können Eingabefelder konfiguriert werden, die in der Sidebar angezeigt werden sollen, um weitere Informationen zu dieser Antwort einzuholen.",
      "saveLabel": {
        "edit": "Antwort für 0 Ziele bearbeiten | Antwort für 1 Ziel bearbeiten | Antwort für {n} Ziele bearbeiten",
        "add": "Antwort zu 0 Zielen hinzufügen | Antwort zu 1 Ziel hinzufügen | Antwort zu {n} Zielen hinzufügen"
      }
    },
    "answerFieldsTable": {
      "emptyFields": "Neue Eingabefelder mit dem Plus-Button hinzufügen."
    },
    "targetAnswerPicklist": {
      "assigned": "Zugewiesene Antworten",
      "available": "Verfügbare Antworten",
      "empty": "Es wurden keine Antworten gefunden. Erstelle eine neue Antwort in der globalen Antwortenverwaltung.",
      "goToAnswerManagement": "Zur globalen Antwortenverwaltung",
      "tariffAnswerTag": "Tarif"
    }
  },
  "validation": {
    "required": "Dieses Feld wird benötigt",
    "email": "Ungültige Email",
    "minLength": "Mindestens ein Element auswählen | Mindestens {n} Elemente auswählen",
    "maxLength": "Maximal {max} Zeichen erlaubt"
  },
  "errors": {
    "simulation": {
      "summary": "Fehler bei der Simulation",
      "detail": "Die Regel konnte nicht simuliert werden."
    },
    "toast": {
      "common": {
        "get": "Fehler beim Laden",
        "create": "Fehler beim Erstellen",
        "update": "Fehler beim Aktualisieren",
        "delete": "Fehler beim Löschen",
        "options": "Auswahlmöglichkeiten konnten nicht geladen werden"
      },
      "answers": {
        "getAll": "Antworten konnten nicht geladen werden",
        "get": "Antwort konnte nicht geladen werden",
        "create": "Antwort konnte nicht erstellt werden",
        "update": "Antwort konnte nicht aktualisiert werden",
        "delete": "Antwort konnte nicht gelöscht werden"
      },
      "skills": {
        "getAll": "Skills konnten nicht geladen werden",
        "get": "Skill konnte nicht geladen werden",
        "create": "Skill konnte nicht erstellt werden",
        "update": "Skill konnte nicht aktualisiert werden",
        "delete": "Skill konnte nicht gelöscht werden"
      },
      "roles": {
        "getAll": "Rollen konnten nicht geladen werden",
        "get": "Rolle konnte nicht geladen werden",
        "create": "Rolle konnte nicht erstellt werden",
        "update": "Rolle konnte nicht aktualisiert werden",
        "delete": "Rolle konnte nicht gelöscht werden"
      },
      "channels": {
        "getAll": "Kanäle konnten nicht geladen werden",
        "get": "Kanal konnte nicht geladen werden",
        "create": "Kanal konnte nicht erstellt werden",
        "update": "Kanal konnte nicht aktualisiert werden",
        "delete": "Kanal konnte nicht gelöscht werden",
        "potentials": "Potenziale konnten nicht geladen werden",
        "simulate": "Potenziale konnten nicht simuliert werden",
        "disable": "Beim Deaktivieren des Kanals ist ein Fehler aufgetreten.",
        "enable": "Beim Aktivieren des Kanals ist ein Fehler aufgetreten."
      },
      "targets": {
        "getAll": "Ziele konnten nicht geladen werden",
        "get": "Ziel konnte nicht geladen werden",
        "create": "Ziel konnte nicht erstellt werden",
        "update": "Ziel konnte nicht aktualisiert werden",
        "delete": "Ziel konnte nicht gelöscht werden"
      },
      "tariffs": {
        "getAll": "Tarife konnten nicht geladen werden",
        "get": "Tarif konnte nicht geladen werden",
        "create": "Tarif konnte nicht erstellt werden",
        "update": "Tarif konnte nicht aktualisiert werden",
        "delete": "Tarif konnte nicht gelöscht werden"
      },
      "rules": {
        "getAll": "Regeln konnten nicht geladen werden",
        "get": "Regel konnte nicht geladen werden",
        "create": "Regel konnte nicht erstellt werden",
        "update": "Regel konnte nicht aktualisiert werden",
        "delete": "Regel konnte nicht gelöscht werden"
      },
      "users": {
        "getAll": "Benutzer konnten nicht geladen werden",
        "get": "Benutzer konnte nicht geladen werden",
        "create": "Benutzer konnte nicht erstellt werden",
        "update": "Benutzer konnte nicht aktualisiert werden",
        "delete": "Benutzer konnte nicht gelöscht werden"
      },
      "teams": {
        "getAll": "Teams konnten nicht geladen werden",
        "get": "Team konnte nicht geladen werden",
        "create": "Team konnte nicht erstellt werden",
        "update": "Team konnte nicht aktualisiert werden",
        "delete": "Team konnte nicht gelöscht werden"
      },
      "auditLogs": {
        "getAll": "Logs konnten nicht geladen werden"
      },
      "ios": {
        "getAll": "IOs konnten nicht geladen werden"
      },
      "dashboard": {
        "funnel": "Die Daten des Conversion Funnels konnten nicht geladen werden",
        "data": "Dashboard-Daten konnten nicht geladen werden",
        "filters": "Dashboard-Filter konnten nicht geladen werden"
      },
      "billing": {
        "context": "Abrechungsdaten konnten nicht geladen werden",
        "bookSeats": "Bei der Buchung der Seats ist ein Fehler aufgetreten",
        "billingPortal": "Das Abrechnungsportal konnte nicht abgerufen werden",
        "seatsBelowUserCount": "Es können nicht weniger Seats gebucht werden, als aktuell {count} Benutzer vorhanden sind",
        "advantageNoticePeriodReached": "Der Advantage-Plan kann während der Kündigungsfrist nicht geändert werden",
        "paymentMethodMissing": "Für den automatischen Einzug muss bei Stripe zuerst eine Zahlungsmethode hinterlegt werden."
      },
      "catalog": {
        "getAll": "Katalog konnte nicht geladen werden",
        "update": "Eintrag konnte nicht aktualisiert werden",
        "delete": "Eintrag konnte nicht gelöscht werden",
        "reassign": "Eintrag konnte nicht neu zugeordnet werden"
      },
      "settings": {
        "get": "Einstellungen konnten nicht geladen werden",
        "update": "Einstellungen konnten nicht gespeichert werden"
      },
      "customerImport": {
        "jobStatus": "Import Status konnte nicht geladen werden",
        "cancel": "Import konnte nicht abgebrochen werden"
      },
      "targetExport": {
        "title": "Fehler beim Export",
        "message": "Beim Export ist ein Fehler aufgetreten"
      },
      "authentication": {
        "expired": {
          "title": "Sitzung abgelaufen",
          "message": "Bitte erneut anmelden."
        }
      },
      "validation": {
        "title": "Validierungsfehler",
        "message": "Bitte die Eingaben überprüfen"
      }
    }
  },
  "notifications": {
    "common": {
      "saved": "Erfolgreich gespeichert",
      "entriesDeactivated": "Der Eintrag wurde erfolgreich deaktiviert. | {count} Einträge wurden deaktiviert.",
      "entriesActivated": "Der Eintrag wurde erfolgreich aktiviert. | {count} Einträge wurden aktiviert.",
      "deleteMultiple": "Es wurden {deletedCount} von {totalCount} Einträgen gelöscht."
    },
    "billing": {
      "booking": {
        "summary": "Buchung abgeschlossen",
        "detail": "Die Buchung wurde erfolgreich abgeschlossen."
      }
    },
    "settings": {
      "update": {
        "detail": "Die Einstellungen wurden erfolgreich gespeichert."
      }
    },
    "users": {
      "create": {
        "summary": "Benutzer erstellt",
        "detail": "Der Benutzer wurde erfolgreich erstellt. Eine E-Mail mit Einladungslink wurde verschickt."
      },
      "update": {
        "summary": "Benutzer aktualisiert",
        "detail": "Der Benutzer wurde erfolgreich aktualisiert."
      },
      "delete": {
        "summary": "Benutzer gelöscht",
        "detail": "Der Benutzer wurde erfolgreich gelöscht."
      }
    },
    "catalog": {
      "update": {
        "summary": "Katalog Eintrag aktualisiert",
        "detail": "Der Katalog Eintrag wurde erfolgreich aktualisiert."
      },
      "delete": {
        "summary": "Katalog Eintrag gelöscht",
        "detail": "Der Katalog Eintrag wurde erfolgreich gelöscht."
      },
      "cancelImport": {
        "summary": "Import abgebrochen",
        "detail": "Der Import Job wurde abgebrochen."
      }
    },
    "targets": {
      "update": {
        "summary": "Ziel aktualisiert",
        "detail": "Das Ziel wurde aktualisiert."
      },
      "toggleDisabledStatus": {
        "deactivated": "Ziel deaktiviert | Ziele deaktiviert",
        "activated": "Ziel aktiviert | Ziele aktiviert"
      },
      "delete": {
        "summary": "Ziel gelöscht | Ziele gelöscht",
        "detail": "Das Ziel wurde erfolgreich gelöscht."
      },
      "export": {
        "summary": "Export erfolgreich",
        "detail": "Der Export wurde erfolgreich gestartet."
      },
      "warnings": {
        "bitmapRebuildNotTriggered": {
          "summary": "Neuberechnung nicht gestartet",
          "detail": "Das Ziel ist gespeichert, aber die Neuberechnung der Handlungsempfehlungen konnte nicht gestartet werden. Die Empfehlungen für dieses Ziel bleiben leer, bis die nächste planmäßige Neuberechnung läuft."
        }
      }
    },
    "tariffs": {
      "create": {
        "summary": "Tarif erstellt",
        "detail": "Der Tarif wurde erfolgreich erstellt."
      },
      "update": {
        "summary": "Tarif aktualisiert",
        "detail": "Der Tarif wurde erfolgreich aktualisiert."
      },
      "import": {
        "summary": "Preisliste importiert",
        "detail": "Die Preisliste wurde erfolgreich importiert."
      },
      "deletePriceList": {
        "summary": "Preisliste gelöscht",
        "detail": "Die Preisliste wurde erfolgreich gelöscht."
      },
      "mapping": {
        "summary": "Tarif-Mapping gespeichert",
        "detail": "Das Tarif-Mapping wurde erfolgreich aktualisiert."
      },
      "toggleDisabledStatus": {
        "deactivated": "Tarif deaktiviert | Tarife deaktiviert",
        "activated": "Tarif aktiviert | Tarife aktiviert",
        "skippedExternallyManaged": "Nicht geändert (API-Tarife): {names}"
      }
    },
    "channels": {
      "create": {
        "summary": "Kanal erstellt",
        "detail": "Der Kanal wurde erfolgreich erstellt."
      },
      "update": {
        "summary": "Kanal aktualisiert",
        "detail": "Der Kanal wurde erfolgreich aktualisiert."
      },
      "toggleDisabledStatus": {
        "deactivated": "Kanal deaktiviert | Kanäle deaktiviert",
        "activated": "Kanal aktiviert | Kanäle aktiviert"
      },
      "delete": {
        "summary": "Kanal gelöscht | Kanäle gelöscht",
        "detail": "Der Kanal wurde erfolgreich gelöscht."
      }
    },
    "rules": {
      "update": {
        "summary": "Regel aktualisiert",
        "detail": "Die Regel wurde aktualisiert."
      },
      "simulation": {
        "builtNewAtoms": {
          "summary": "Neue Bedingung berechnet",
          "detail": "Für diese Simulation musste eine neue Bedingung erstmalig berechnet werden."
        }
      }
    },
    "skills": {
      "create": {
        "summary": "Skill erstellt",
        "detail": "Der Skill wurde erfolgreich erstellt."
      },
      "update": {
        "summary": "Skill aktualisiert",
        "detail": "Der Skill wurde erfolgreich aktualisiert."
      },
      "delete": {
        "summary": "Skill gelöscht",
        "detail": "Der Skill wurde erfolgreich gelöscht."
      }
    },
    "teams": {
      "create": {
        "summary": "Team erstellt",
        "detail": "Das Team wurde erfolgreich erstellt."
      },
      "update": {
        "summary": "Team aktualisiert",
        "detail": " Das Team wurde aktualisiert."
      },
      "delete": {
        "summary": "Team gelöscht",
        "detail": "Das Team wurde erfolgreich gelöscht."
      }
    },
    "roles": {
      "create": {
        "summary": "Rolle erstellt",
        "detail": "Die Rolle wurde erfolgreich erstellt."
      },
      "update": {
        "summary": "Rolle aktualisiert",
        "detail": "Die Rolle wurde erfolgreich aktualisiert."
      },
      "delete": {
        "summary": "Rolle gelöscht",
        "detail": "Die Rolle wurde erfolgreich gelöscht."
      }
    },
    "answers": {
      "create": {
        "summary": "Antwort erstellt",
        "detail": "Die Antwort wurde erfolgreich erstellt."
      },
      "update": {
        "summary": "Antwort aktualisiert",
        "detail": "Die Antwort wurde erfolgreich aktualisiert."
      },
      "delete": {
        "summary": "Antwort gelöscht",
        "detail": "Die Antwort wurde erfolgreich gelöscht."
      },
      "unlink": {
        "detail": "Die Verknüpfungen wurden erfolgreich entfernt."
      },
      "duplicate": {
        "detail": "Die Antwort wurde erfolgreich dupliziert"
      }
    }
  },
  "views": {
    "accessDenied": {
      "title": "Zugriff verweigert",
      "message": "Es fehlen die nötigen Berechtigungen, um diese Seite zu sehen.\nEinen Administrator kontaktieren, um Zugriff zu erhalten."
    },
    "noSeatsAvailable": {
      "title": "Nicht genug Seats verfügbar",
      "message": "Es sind aktuell nicht genug Seats verfügbar. Weitere Seats müssen erst gebucht werden."
    },
    "dashboard": {
      "title": "Dashboard",
      "funnelTitle": "Conversion Funnel",
      "fakeData": {
        "toggle": "Demodaten",
        "banner": "Demodaten aktiv: Alle Kennzahlen auf dieser Seite sind zufällig erzeugt und zeigen keine echten Daten."
      },
      "last30Days": {
        "tooltipRelative": "relatives Wachstum bzgl. des unmittelbar vorangegangenen, gleich langen Zeitraums",
        "tooltipAbsolute": "Wachstum bzgl. des unmittelbar vorangegangenen, gleich langen Zeitraums (abs. Prozentpunkte)",
        "playedOut": "Ausgespielt",
        "recorded": "Erfasst",
        "filteredOutHint": "Durch den Zieltyp-Filter ausgeblendet"
      },
      "analysis": "Analyse",
      "topSuccesses": "Erfolgreichste Ziele (Top 10)",
      "channelSuccesses": "Erfolgsquote je Kanal",
      "performanceRecords": "Gesamtübersicht",
      "salesValueByWeek": {
        "title": "Sales Value",
        "legend": "Sales Value",
        "empty": "Kein Sales Value im gewählten Zeitraum vorhanden"
      },
      "distribution": "Verteilung ausgespielter Ziele",
      "positiveAnswers": "Positive Antworten (Top 5)",
      "negativeAnswers": "Negative Antworten (Top 5)",
      "notAddressedAnswers": "Nicht angesprochen (Top 5)",
      "labels": {
        "successRate": "Erfolgsquote",
        "addressRate": "Ansprachequote",
        "recorded": "Erfasst",
        "addresses": "Ansprachen",
        "successes": "Erfolge",
        "answered": "beantwortet",
        "notAnswered": "nicht beantwortet",
        "notAddressed": "nicht angesprochen",
        "others": "Sonstige"
      }
    },
    "targets": {
      "title": "@:common.targets",
      "salesValue": "Sales Value",
      "commodity": "Sparte",
      "draft": "Entwurf",
      "draftTooltip": "Regeln oder Antworten fehlen",
      "noSkills": "wird allen Agenten ausgespielt",
      "noChannels": "keine Kanäle zugewiesen",
      "noRules": "keine Regeln konfiguriert",
      "createTarget": "@:common.target erstellen",
      "exportDialog": {
        "button": "Ergebnisse exportieren",
        "title": "Antworten exportieren",
        "targetCount": "Anzahl ausgewählter Ziele: {count}",
        "selectDateRange": "Zeitraum für den Export auswählen",
        "allResults": "Alle Ergebnisse"
      },
      "disableWarning": "Deaktivierte Einträge werden aus allen Kanälen entfernt. Zugehörige IOs werden gelöscht.",
      "rules": "Regeln",
      "answers": "Antworten",
      "tariffs": "Tarife",
      "blocks": "Sperrfristen",
      "detailPage": {
        "title": "@:common.target \"{name}\" bearbeiten",
        "self": "Selbst",
        "disabledChannels": "@:channels.title - können nur bei aktivierten Zielen bearbeitet werden",
        "blockDuration": "Gesperrt für (in Tagen)",
        "answerType": "Antwort-Typ",
        "noAnswers": "Es sind noch keine Antworten vorhanden.",
        "blockColumn": {
          "blocks": "Zu sperrendes Ziel",
          "blockedBy": "Sperrendes Ziel"
        },
        "savingDraftConfirmation": "Ziel ist unvollständig. Es kann daher nicht ausgespielt werden.",
        "blockTitle": {
          "blockedBy": "Sperrung durch Antworten anderer Ziele",
          "blocks": "Ziele gesperrt durch Antwort-Typ"
        },
        "blockDialogTitle": {
          "add": "Sperrfrist hinzufügen",
          "edit": "Sperrfrist bearbeiten"
        },
        "tariffs": {
          "description": "Die Reihenfolge der zugewiesenen Tarife bestimmt die Priorität im Backend und in der Sidebar.",
          "addLabel": "Tarif zuweisen",
          "empty": "Diesem Ziel sind noch keine Tarife zugewiesen.",
          "notReadyHint": "Für diesen Tarif gibt es keine aktive Preisliste. Der Tarif wird nicht in der Sidebar angezeigt."
        },
        "titleSidebar": "Titel in der Sidebar",
        "selectRule": "Wähle eine Kundenselektion aus, um dieses Ziel an alle selektierten Kunden auszuspielen.",
        "openRule": "Selektion öffnen",
        "customerLevelIo": "Auf Kundenebene ausspielen",
        "customerLevelIoTooltip": "Auch wenn die Selektion Vertragsfelder enthält, wird nur eine Aufgabe pro Kunde erzeugt - ohne Vertragszuordnung."
      },
      "deleteAnswer": {
        "title": "Antwort löschen",
        "message": "Soll die Antwort wirklich gelöscht werden?"
      },
      "answerFieldTypes": {
        "text": "Text",
        "number": "Zahl",
        "date": "Datum",
        "boolean": "Ja/Nein",
        "dropdown": "Einfachauswahl",
        "multidropdown": "Mehrfachauswahl",
        "phone_number": "Rufnummer",
        "email": "E-Mail Adresse",
        "iban": "IBAN",
        "date_of_birth": "Geburtsdatum"
      },
      "ruleEditor": {
        "actions": {
          "add": "Regel hinzufügen",
          "split": "Regeln hinzufügen",
          "connectEndNode": "Endpunkt verbinden",
          "toggleFullscreen": "Vollbild",
          "toggleDirection": "Ausrichtung ändern",
          "simulator": "Simulator",
          "confirmEdit": "Bearbeitung bestätigen",
          "addShort": "Regel"
        },
        "workflowNode": {
          "start": "Start",
          "end": "Ende"
        },
        "ruleNode": {
          "field": "Feld",
          "operator": "Operator",
          "value": "Wert",
          "values": "Werte",
          "timeUnit": "Einheit",
          "count": "Anzahl",
          "missingConnection": "Verbindung fehlt.",
          "includeEmpty": "leere Werte einschließen",
          "deletedFieldOption": "Dieses Feld existiert nicht mehr im Katalog. Diese Bedingung muss entfernt werden."
        },
        "newRule": "Neue Regel"
      },
      "simulator": {
        "info": "Hier simulieren, wie viele Kundensätze unter den aktuellen Regeln gefunden werden.",
        "size": "Stichprobengröße",
        "simulate": "Simulieren",
        "loading": "Regeln werden simuliert",
        "results": "Es wurden keine Treffer gefunden. | Es wurde {count} Treffer gefunden. | Es wurden {count} Treffer gefunden."
      },
      "createRule": "Regel erstellen"
    },
    "channels": {
      "title": "Kanäle",
      "userCount": "Anzahl Benutzer",
      "detailPage": {
        "title": {
          "create": "Kanal erstellen",
          "edit": "Kanal \"{name}\" bearbeiten"
        },
        "notFound": "Kanal nicht gefunden",
        "targetPrioritization": "Zielpriorisierung",
        "infoMessage": {
          "noChanges": "Priorisierung kann durch Drag and Drop geändert und nach einer Simulation übernommen werden.",
          "changes": "Die Potenziale der Ziele sind nicht aktuell. Jetzt Potenziale simulieren, um die Ansicht zu aktualisieren.",
          "simulationSuccess": "Simulation abgeschlossen"
        },
        "addUsers": "Benutzer zum Kanal hinzufügen",
        "addTarget": "@:common.target hinzufügen",
        "simulatePotentials": "Potenziale simulieren",
        "resetPrioritizationChanges": "Änderungen zurücksetzen?",
        "noTargetsAvailable": "Keine weiteren @:common.targets verfügbar",
        "noTargetsAssigned": "Keine @:common.targets zugeordnet",
        "priority": "Priorität",
        "highestPriority": "Höchste Priorität",
        "increasePriority": "Priorität erhöhen",
        "lowestPriority": "Niedrigste Priorität",
        "decreasePriority": "Priorität verringern",
        "potential": "Potenzial",
        "potentialTotal": "Potenzial ges.",
        "tooltips": {
          "totalCustomerCount": "Gesamtkundenanzahl",
          "failedToGetTotalCustomerCount": "Gesamtkundenanzahl konnte nicht abgerufen werden",
          "potential": "Das individuelle Potenzial jeder Maßnahme. Ändert sich basierend auf der Priorisierung.",
          "potentialTotal": "Das Gesamtpotenzial bleibt konstant, unabhängig von der Priorisierung der einzelnen Maßnahmen.",
          "potentialChange": "Veränderung: {absoluteChange} ({percentageChange}%)",
          "rankChange": {
            "increased": "Priorität erhöht von {previousRank} auf {currentRank}",
            "decreased": "Priorität verringert von {previousRank} auf {currentRank}",
            "new": "Neu hinzugefügt"
          }
        },
        "confirmation": {
          "removeTarget": "Soll das @:common.target \"{target}\" wirklich aus der Priorisierung entfernt werden?"
        },
        "simulationDialog": {
          "loading": {
            "title": "Simulation wird ausgeführt",
            "message": "Die Simulation läuft und berechnet die Ergebnisse. Dies kann einige Minuten dauern."
          },
          "success": {
            "title": "Simulation erfolgreich abgeschlossen",
            "message": "Die Potenziale wurden basierend auf der neuen Priorisierung berechnet."
          }
        },
        "potentialsLoading": "Die Berechnung der Potenziale läuft. Dies kann einen Moment dauern…"
      }
    },
    "userManagement": {
      "title": "Benutzer",
      "users": {
        "edit": "{count} Benutzer bearbeiten",
        "selectedUserCount": "Anzahl ausgewählter Benutzer: {count}",
        "detailPage": {
          "title": {
            "create": "Benutzer erstellen",
            "edit": "Benutzer \"{name}\" bearbeiten"
          },
          "userData": "Benutzerdaten",
          "assignedTeam": "Zugewiesenes Team",
          "assignedChannels": "Zugewiesene Kanäle",
          "permissions": "Berechtigungen",
          "invite": "Einladen"
        }
      },
      "noSeats": "Keine freien Seats verfügbar",
      "addUser": "Benutzer einladen",
      "promptUserDelete": "Soll der Benutzer wirklich gelöscht werden?",
      "deleteUser": "Benutzer löschen"
    },
    "catalog": {
      "title": "Katalog",
      "alias": "Alias",
      "dataLevel": {
        "title": "Datenebene",
        "customer": "Kunde",
        "address": "Adresse",
        "contract": "Vertrag",
        "answers": "Antworten"
      },
      "editEntry": "Katalog Eintrag bearbeiten",
      "viewEntry": "Katalog Eintrag ansehen",
      "coverage": "Abdeckung",
      "noData": "Daten in die Datenbank laden, um zu beginnen.",
      "unassignedEnhancements": {
        "tooltip": "Nicht zugeordnete Aliase und Beschreibungen",
        "title": "Nicht zugeordnete Einträge",
        "description": "Folgende Einträge sind nicht mehr zugeordnet.",
        "reassign": "Neu zuordnen"
      },
      "import": {
        "statusDialog": {
          "button": "Import Status",
          "title": "Letzter Import Job",
          "cancelButton": "Import abbrechen",
          "startedAtDate": "Gestartet am",
          "finishedAtDate": "Beendet am",
          "inputCount": "Übertragene Daten",
          "inputCountDetails": "{customers} Kunden, {contracts} Verträge, {uniqueCustomers} Eindeutige Kunden",
          "importedCount": "Importierte Daten",
          "importedCountDetails": "{customers} Kunden, {contracts} Verträge",
          "errorMessage": "Fehlermeldung",
          "importErrors": "Meldungen",
          "field": "Feld",
          "value": "Wert",
          "category": "Kategorie",
          "categories": {
            "error": "Fehler",
            "info": "Hinweis"
          }
        },
        "status": {
          "pending": "Wartet auf Ausführung",
          "ongoing": "In Bearbeitung",
          "completed": "Erfolgreich",
          "failed": "Fehlgeschlagen",
          "cancelling": "Wird abgebrochen",
          "cancelled": "Abgebrochen"
        },
        "errorDescriptions": {
          "duplicate_key": "Doppelte Kunden-IDs beim Import gefunden"
        }
      },
      "status": {
        "approved": "Freigegeben",
        "not_approved": "Gesperrt"
      },
      "dataType": {
        "datetime64us": "Datum",
        "boolean": "Ja/Nein",
        "Int64": "Numerisch",
        "Float64": "Numerisch (Gleitkommazahl)",
        "string": "Text"
      }
    },
    "rules": {
      "title": "Kundenselektion",
      "detailPage": {
        "title": "Regel \"{name}\" bearbeiten",
        "noTargetsAssigned": "Keine Ziele zugewiesen"
      },
      "conditions": "Bedingungen"
    },
    "administration": {
      "title": "Administration"
    },
    "tariffs": {
      "title": "Tarife",
      "description": "Tarife anlegen, bearbeiten und Preislisten verwalten.",
      "draft": "Entwurf",
      "columns": {
        "defaultConsumptionKwh": "Standardverbrauch (kWh)",
        "lastUploadAt": "Letzter Upload",
        "activeSince": "Aktiv seit",
        "activePriceList": "Aktive Preisliste",
        "sidebarStatus": "Sidebar-Status"
      },
      "commodities": {
        "electricity": "Strom",
        "gas": "Gas"
      },
      "hasActivePriceList": {
        "yes": "Vorhanden",
        "no": "Fehlt"
      },
      "status": {
        "ready": "Bereit",
        "missing-active-price-list": "Aktive Preisliste fehlt",
        "missing-mapping": "Mapping fehlt",
        "externally-managed": "Über API versorgt"
      },
      "externallyManagedTag": "API-Tarif",
      "priceComparisonFieldsHint": {
        "message": "Der aktuelle Tarif eines Kunden wird in der Sidebar nicht angezeigt, solange \"Aktueller Arbeitspreis\" und \"Aktueller Grundpreis\" in den Einstellungen nicht konfiguriert sind.",
        "configure": "Zu den Einstellungen"
      },
      "validation": {
        "duplicateName": "Ein Tarif mit diesem Namen existiert bereits."
      },
      "createDialog": {
        "title": "Tarif erstellen"
      },
      "detailPage": {
        "title": "Tarif \"{name}\"",
        "loadingTitle": "Tarifdetails",
        "readonlyInfo": "Sie haben nur Leserechte für Tarife.",
        "priceLists": {
          "title": "Preislistenverlauf",
          "validFrom": "Gültig ab",
          "uploadedAt": "Hochgeladen am",
          "empty": "Für diesen Tarif wurden noch keine Preislisten importiert.",
          "reimportError": "Diese Preisliste konnte mit dem aktuellen Mapping nicht neu importiert werden.",
          "deleteConfirm": "Soll diese Preisliste wirklich gelöscht werden?",
          "status": {
            "active": "Aktiv",
            "scheduled": "Geplant",
            "archived": "Archiviert"
          }
        },
        "upload": {
          "title": "Preisliste importieren",
          "description": "CSV-Datei auswählen, zukünftiges Startdatum festlegen und als geplante oder aktive Preisliste importieren.",
          "mappingRequired": "Preislisten können erst importiert werden, nachdem ein Tarif-Mapping gespeichert wurde.",
          "validFrom": "Gültig ab",
          "fileLabel": "CSV-Datei",
          "retry": "Erneut versuchen",
          "errorSummary": "Import fehlgeschlagen",
          "error": "Der Upload oder Import der Preisliste ist fehlgeschlagen. Bitte erneut versuchen."
        },
        "mapping": {
          "title": "Tarif-Mapping",
          "empty": "Für diesen Tarif wurde noch kein Mapping gespeichert. Speichern Sie zuerst ein explizites Mapping.",
          "lookupFieldsTitle": "Lookup-Felder",
          "lookupFieldsDescription": "Alle konfigurierten Identifier müssen für dieselbe Zeile exakt übereinstimmen.",
          "csvColumn": "CSV-Spalte",
          "contractField": "Vertragsfeld",
          "workingPriceColumn": "Arbeitspreis-Spalte",
          "basePriceColumn": "Grundpreis-Spalte",
          "addIdentifier": "Identifier hinzufügen",
          "reimportWarning": "Das Speichern dieses Mappings importiert alle Preislisten erneut.",
          "error": "Das Tarif-Mapping konnte nicht gespeichert werden.",
          "validation": {
            "identifierRequired": "Mindestens ein Identifier ist erforderlich.",
            "identifierFields": "Jeder Identifier benötigt eine CSV-Spalte und ein Vertragsfeld."
          }
        },
        "bonusTiers": {
          "title": "Bonus-Staffel",
          "description": "Pro Verbrauchsstufe einen Bonus festlegen. Die Grenzen sind inklusiv und dürfen sich nicht überschneiden.",
          "empty": "Für diesen Tarif sind noch keine Bonus-Staffeln konfiguriert.",
          "minConsumptionKwh": "Ab Verbrauch (kWh)",
          "maxConsumptionKwh": "Bis Verbrauch (kWh)",
          "bonusAmountEur": "Bonus (€)",
          "addTier": "Staffel hinzufügen",
          "error": "Die Bonus-Staffel konnte nicht gespeichert werden.",
          "validation": {
            "rowBounds": "Der untere Grenzwert darf den oberen nicht überschreiten.",
            "overlap": "Die Bonus-Staffeln dürfen sich nicht überschneiden: [{previousMin} – {previousMax}] und [{currentMin} – {currentMax}]."
          }
        }
      }
    },
    "auditLogs": {
      "title": "Logs",
      "columns": {
        "action": "Aktion",
        "category": "Kategorie",
        "datetime": "Zeitpunkt",
        "id": "Eintrags-ID",
        "userId": "Benutzer-ID"
      },
      "categories": {
        "team": "Team",
        "user": "Benutzer"
      },
      "actions": {
        "userCreated": "Benutzer {userId} erstellt",
        "userDeleted": "Benutzer {userId} gelöscht",
        "teamCreated": "Team \"{teamName}\" erstellt",
        "teamDeleted": "Team \"{teamName}\" gelöscht",
        "teamReportingLevelSet": "Reportingebene für Team \"{teamName}\" auf {reportingLevel} gesetzt",
        "teamAgentStatisticsSet": "Agentenstatistik für Team \"{teamName}\" {state}",
        "teamLeaderboardSet": "Rangliste für Team \"{teamName}\" {state}"
      },
      "reportingLevels": {
        "TEAM": "Teamebene",
        "USER": "Benutzerebene"
      },
      "switchStates": {
        "on": "eingeschaltet",
        "off": "ausgeschaltet"
      }
    },
    "billing": {
      "title": "Abrechnung",
      "description": "Abrechnungsrelevante Inhalte verwalten",
      "billingPortal": "Zum Abrechnungsportal",
      "seats": "Seats",
      "seatTypes": {
        "flex": "Flex",
        "advantage": "Advantage"
      },
      "collectionMethods": {
        "automatic": "Automatischer Einzug",
        "bankTransfer": "Rechnung per Banküberweisung"
      },
      "collectionMethod": {
        "title": "Zahlungsart auswählen",
        "description": "Hier festlegen, wie die Rechnungen dieser Installation bezahlt werden",
        "futureOnly": "Eine Änderung gilt ab der nächsten Rechnung und ändert bereits gestellte Rechnungen nicht.",
        "paymentMethodMissing": "Automatischer Einzug ist nicht möglich, solange bei Stripe keine Zahlungsmethode hinterlegt ist.",
        "automatic": {
          "text1": "Der fällige Betrag wird automatisch über die bei Stripe hinterlegte Zahlungsmethode eingezogen.",
          "text2": "Es ist keine Aktion des Kunden erforderlich."
        },
        "bankTransfer": {
          "text1": "Es wird eine Rechnung gestellt, die per Banküberweisung auf das dort genannte Konto bezahlt wird.",
          "text2": "Die Rechnung ist innerhalb von 30 Tagen nach Rechnungsstellung fällig.",
          "text3": "Für jeden Abrechnungszeitraum ist eine eigene Überweisung erforderlich."
        }
      },
      "plan": {
        "current": "Aktuelles Abonnement",
        "scheduled": "Geplantes Abonnement",
        "title": "Plan",
        "description": "Hier kann der Plan angepasst werden.",
        "currentPlan": "Aktueller Plan",
        "seatType": "Seat-Modell",
        "seatCount": "Anzahl Seats",
        "collectionMethod": "Zahlungsart",
        "monthlyCost": "Monatliche Kosten dieser Laufzeit",
        "termStart": "Laufzeitbeginn",
        "termEnd": "Laufzeitverlängerung",
        "noticePeriod": "Kündigungsfrist",
        "scheduledInfo": {
          "termStart": "Die folgenden Buchungsoptionen treten zum Stichtag des {termStart} ein.",
          "noticePeriod": "Bis zur Kündigungsfrist am {noticePeriod} können noch Änderungen vorgenommen werden."
        }
      },
      "seatModel": {
        "title": "Seat-Modell auswählen",
        "description": "Hier zwischen Flex-Seats und Advantage-Seats wählen",
        "flex": {
          "text1": "Ein Flex-Seat kostet {price} pro Monat.",
          "text2": "Die Anzahl kann jederzeit angepasst werden und wird in die nächste Monatsrechnung anteilig verrechnet.",
          "text3": "Ein Wechsel von Flex-Seats zu Advantage-Seats ist jederzeit möglich."
        },
        "advantage": {
          "text1": "Ein Advantage-Seat kostet {price} pro Monat.",
          "text2": "Die Anzahl kann jederzeit erhöht, jedoch erst zum Ende der Laufzeit verringert werden.",
          "text3": "Ein Wechsel von Advantage-Seats zu Flex-Seats ist zum Ende der Laufzeit möglich."
        },
        "ladder": {
          "seatRange": "Seats",
          "unitAmount": "Preis pro Seat",
          "range": "{from} bis {to} Seats",
          "openEndedRange": "Ab {from} Seats"
        }
      },
      "seatCount": {
        "title": "Anzahl der Seats auswählen",
        "usedSeats": "{count} genutzte Seats",
        "availableSeats": "{count} verfügbare Seats",
        "missingSeats": "{count} fehlende Seats",
        "effectiveRate": "Die eingegebene Anzahl Seats kostet aktuell {amount} pro Seat.",
        "nextTier": "{count} weiterer Seat erreicht die nächste günstigere Stufe zu {amount} pro Seat. | {count} weitere Seats erreichen die nächste günstigere Stufe zu {amount} pro Seat.",
        "belowLowerBound": "{count} Seat weniger fällt in die nächst teurere Stufe: dort kostet ein Seat {amount}. | {count} Seats weniger fallen in die nächst teurere Stufe: dort kostet ein Seat {amount}."
      },
      "customerCapacity": {
        "title": "Customer Capacity Level",
        "currentCustomerCount": "Aktuelle Kundenanzahl",
        "maxCustomerCount": "Max. Kundenanzahl dieses Monats",
        "history": "Kundenanzahl-Historie",
        "customerCount": "Kundenanzahl",
        "level": "Level",
        "price": "Preis pro Monat",
        "rangeInfo": "{firstUnit} bis {lastUnit}",
        "maxRangeInfo": "> {firstUnit}",
        "priceOnRequest": "Auf Anfrage",
        "fixedLine": "Level {level} - Festpreis gem. Vereinbarung, {monthlyAmount}/Monat"
      },
      "bookingSummary": {
        "title": "Buchungszusammenfassung",
        "acceptLabel": {
          "bookWithCosts": "Kostenpflichtig buchen",
          "cancelSeats": "Seats kündigen"
        },
        "confirmText": "Buchung bestätigen und abschließen?",
        "seatChange": {
          "message": "{action}.",
          "booking": "Buchung von {count} {seatType}-Seats",
          "increase": "Erhöhung auf {count} {seatType}-Seats",
          "decrease": "Kürzung auf {count} {seatType}-Seats",
          "decreaseAdvantage": "@:views.billing.bookingSummary.seatChange.decrease {runtimeInfo}",
          "change": "Wechsel von {oldCount} {oldSeatType}-Seats auf {count} {seatType}-Seats",
          "runtimeInfo": "zur nächsten Laufzeit"
        },
        "info": {
          "booking": {
            "flex": "Die Abrechnung erfolgt sofort anteilig für den Rest des Monats.",
            "advantage": "Die Advantage-Seats starten mit einer Laufzeit von zwei Jahren."
          },
          "change": {
            "flex": "Die Änderung erfolgt zum Beginn der nächsten Laufzeit am {termEnd}.",
            "advantage": "Bereits bezahlte Seats werden anteilig zurückerstattet.",
            "advantage2": "Die Advantage-Seats-Laufzeit beginnt sofort."
          },
          "increase": {
            "flex": "Die Abrechnung der neuen Seats erfolgt anteilig in der nächsten Monatsrechnung.",
            "advantage": "Die Abrechnung der neuen Seats erfolgt anteilig für die verbleibende Laufzeit."
          },
          "decrease": {
            "flex": "Bereits bezahlte Seats werden in der nächsten Monatsrechnung anteilig zurückerstattet.",
            "advantage": "Die Änderung erfolgt zum Beginn der nächsten Laufzeit am {termEnd}."
          }
        },
        "price": {
          "message": "Die monatlichen Kosten einer Laufzeit betragen {price}",
          "increase": "Dies erhöht die monatlichen Kosten von {oldPrice} auf {newPrice}"
        },
        "collectionMethod": {
          "message": "Zahlungsart: {method}. Gilt ab der nächsten Rechnung."
        }
      }
    },
    "settings": {
      "title": "Einstellungen",
      "description": "Globale intellivend-Einstellungen verwalten.",
      "sidebarSearchParameter": {
        "label": "Sidebar Suchparameter",
        "description": "Wähle ein zusätzliches Katalogfeld aus, das in der Sidebar als sekundäre Kundensuche verwendet wird."
      },
      "sidebarShowOnlyPrioritizedIos": {
        "label": "Nur höchstpriorisierte Aufgaben anzeigen",
        "description": "Wenn die Option aktiv ist werden in der Aufgabenliste für jeden Zieltyp (Sale, Insight, Lead) nur die Aufgabe mit der höchsten Priorität angezeigt."
      },
      "contractComparisonFields": {
        "title": "Vertragsvergleichsfelder",
        "description": "Diese Felder werden für den Laufzeitvergleich mit dem aktuellen Vertrag verwendet.",
        "currentWorkingPriceField": "Aktueller Arbeitspreis",
        "currentBasePriceField": "Aktueller Grundpreis",
        "consumptionField": "Verbrauchsfeld",
        "contractNameField": "Vertragsname"
      },
      "contractAddressFields": {
        "title": "Lieferadressfelder",
        "description": "Aus diesen Vertragsfeldern wird die Lieferadresse gelesen, mit der Tarife abgefragt werden.",
        "street": "Straße",
        "houseNumber": "Hausnummer",
        "postcode": "Postleitzahl",
        "city": "Ort"
      },
      "consumptionTiers": {
        "title": "Verbrauchsstufen",
        "description": "Ordne Referenzgrößen einem jährlichen Verbrauch in kWh zu. Diese Zuordnung gilt global für alle Tarifempfehlungen.",
        "empty": "Für diesen Bereich sind noch keine Verbrauchsstufen konfiguriert.",
        "consumptionKwh": "Jahresverbrauch (kWh)",
        "addTier": "Stufe hinzufügen",
        "commodity": {
          "electricity": "Strom (Personenanzahl)",
          "gas": "Gas (Wohnfläche in m²)"
        },
        "referenceValue": {
          "electricity": "Personenanzahl",
          "gas": "Wohnfläche (m²)"
        },
        "validation": {
          "rowValues": "Referenzwert und Jahresverbrauch müssen positive Ganzzahlen sein.",
          "duplicateReferenceValue": "Der Referenzwert {referenceValue} ist mehrfach vergeben. Jeder Referenzwert darf pro Sparte nur einmal verwendet werden."
        }
      }
    },
    "userRoleManagement": {
      "title": "Rollen"
    },
    "skillManagement": {
      "editSkill": "Skill bearbeiten",
      "addSkill": "Skill hinzufügen",
      "promptSkillDelete": "Soll der Skill \"{skill}\" wirklich gelöscht werden?",
      "deleteSkillTooltip": {
        "users": "Der Eintrag kann nicht gelöscht werden, da er noch Benutzern zugeordnet ist.",
        "targets": "Der Eintrag kann nicht gelöscht werden, da er noch Zielen zugeordnet ist."
      }
    },
    "teamManagement": {
      "title": "Teams",
      "reportingLevel": "Reportingebene",
      "agentStatistics": "Agentenstatistik",
      "leaderboard": "Rangliste",
      "leaderboardDisabledTooltip": {
        "reportingLevel": "Nur bei Reportingebene \"Benutzerebene\" verfügbar.",
        "agentStatistics": "Nur bei eingeschalteter Agentenstatistik verfügbar."
      },
      "addTeam": "Team hinzufügen",
      "deleteTeam": "Team löschen",
      "promptTeamDelete": "Soll das Team \"{team}\" wirklich gelöscht werden?",
      "deleteTeamTooltip": {
        "users": "Der Eintrag kann nicht gelöscht werden, da er noch Benutzern zugeordnet ist."
      },
      "detailPage": {
        "title": {
          "edit": "Team \"{name}\" bearbeiten",
          "create": "Team erstellen"
        },
        "teamData": "Team Daten",
        "addUsers": "Benutzer zum Team hinzufügen"
      }
    },
    "ssoConfig": {
      "title": "SSO-Konfiguration",
      "description": "Konfigurieren Sie die SSO-Einstellungen für Ihre Anwendung.",
      "supportAccessTitle": "Support-Zugriff",
      "enableSupport": "Support aktivieren",
      "disableSupport": "Support deaktivieren",
      "enableSuccess": "Support-Zugriff aktiviert",
      "disableSuccess": "Support-Zugriff deaktiviert",
      "enableError": "Support-Zugriff konnte nicht aktiviert werden",
      "disableError": "Support-Zugriff konnte nicht deaktiviert werden",
      "saveSuccess": "SSO Konfiguration gespeichert",
      "saveError": "SSO Konfiguration konnte nicht gespeichert werden",
      "oidcTitle": "OIDC Konfiguration",
      "tenantId": "Azure AD Tenant ID",
      "clientId": "Azure AD Client ID",
      "enableSSO": "SSO aktivieren",
      "updateSSO": "SSO aktualisieren",
      "provisioning": "⏳ OIDC-Produkt wird bereitgestellt... Dies kann einige Minuten dauern.",
      "provisioningInProgress": "Identity Provider wird bereit gestellt, dies kann bis zu 10 Minuten dauern",
      "provisioningFailed": "Erstellung fehlgeschlagen, kontaktiere ein Admin oder klicke hier um die Resourcen zu löschen",
      "renewCertificate": "Zertifikat erneuern",
      "certificateRenewed": "Zertifikat erfolgreich erneuert",
      "provisionSuccess": "OIDC erfolgreich bereitgestellt",
      "provisionError": "OIDC-Bereitstellung fehlgeschlagen",
      "terminateSuccess": "Fehlerhafte Ressourcen werden gelöscht",
      "terminateError": "Fehlerhafte Ressourcen konnten nicht gelöscht werden"
    },
    "answerManagement": {
      "title": "Antworten",
      "description": "In dieser Ansicht können Sie Standard- und Zielgruppenspezifische Antworten verwalten.",
      "deleteDialog": {
        "title": "\"{name}\" endgültig löschen?",
        "confirm1": "Antwort \"{name}\" wird aus der globalen Verwaltung entfernt. {links} werden aufgehoben und aus {targets}.",
        "confirm1Links": "Alle Verknüpfungen",
        "confirm1Targets": "allen Zielen entfernt",
        "confirm2": "Dieser Vorgang kann nicht rückgängig gemacht werden. Möchtest du trotzdem fortfahren oder nur die Verknüpfungen aufheben?",
        "unlink": "Nur Verknüpfungen aufheben",
        "delete": "Antwort entgültig löschen"
      },
      "answerDialog": {
        "title": {
          "edit": "Antwort \"{name}\" bearbeiten",
          "add": "Antwort hinzufügen",
          "duplicate": "Antwort \"{name}\" duplizieren",
          "read": "Antwort \"{name}\" ansehen"
        }
      }
    },
    "tariffSandbox": {
      "title": "Tarif-Sandbox",
      "description": "Vergleicht für jeden Vertrag eines Kunden die Tarife aus den Preislisten mit den Produkten der Produkt-API. Es wird nichts gespeichert.",
      "form": {
        "customerNumber": "Kundennummer",
        "target": "Ziel",
        "channel": "Prozesstyp",
        "consumption": "Verbrauch in kWh",
        "consumptionPlaceholder": "Startverbrauch des Vertrags",
        "consumptionWholeNumber": "Nur ganze Zahlen ab 1 erlaubt",
        "optionOmit": "nicht senden",
        "apiRequest": "Anfrage an die Produkt-API",
        "apiRequestHint": "Prozesstyp und Optionen wirken nur auf die Produkt-API. „nicht senden“ lässt eine Option aus der Anfrage weg.",
        "compare": "Vergleichen"
      },
      "comparison": {
        "title": "Vergleich",
        "customer": "Kunde {customerNumber}",
        "target": "Ziel {target}",
        "contracts": "{count} Vertrag | {count} Verträge"
      },
      "notices": {
        "customerNotFound": "Kunde nicht gefunden",
        "noContracts": "Keine Verträge",
        "customerLevelTarget": "Dieses Ziel arbeitet auf Kundenebene und hat keinen Vertrag, der verglichen werden kann."
      },
      "section": {
        "contract": "Vertrag {contractId}",
        "contractWithoutId": "Vertrag ohne Nummer",
        "consumption": "Verbrauch: {consumption}",
        "currentTariff": "Aktueller Tarif",
        "currentTariffUnavailable": "Aktueller Tarif nicht ermittelbar",
        "unnamedTariff": "ohne Namen",
        "failed": "Dieser Vertrag konnte nicht verglichen werden.",
        "cheapestPriceListTariff": "Günstigster Tarif der Preislisten",
        "cheapestApiProduct": "Günstigstes Produkt der Produkt-API",
        "noPricedOffer": "Kein Angebot mit Preis",
        "cheaperThanPriceLists": "{amount} günstiger als die Preislisten",
        "dearerThanPriceLists": "{amount} teurer als die Preislisten",
        "equalToPriceLists": "genauso teuer wie die Preislisten",
        "cheapest": "Günstigstes Angebot"
      },
      "columns": {
        "name": "Name",
        "productKey": "Produktschlüssel",
        "workingPrice": "Arbeitspreis",
        "basePrice": "Grundpreis",
        "bonus": "Bonus",
        "annualCost": "Jahreskosten",
        "consumption": "Verbrauch"
      },
      "priceList": {
        "title": "Preislisten",
        "count": "{count} Tarif | {count} Tarife",
        "noAssignedTariffs": "Dem Ziel sind keine Tarife zugeordnet",
        "reasons": {
          "disabled": "deaktiviert",
          "noMapping": "kein Mapping",
          "noActivePriceList": "keine Preisliste in Kraft",
          "missingContractFields": "ein Vertragsfeld des Mappings fehlt im Vertrag: {fields}",
          "noMatchingRow": "keine passende Zeile in der Preisliste"
        }
      },
      "api": {
        "title": "Produkt-API",
        "count": "{count} Produkt | {count} Produkte",
        "request": "Anfrage",
        "status": "HTTP {status}",
        "noProducts": "Die API hat keine Produkte geliefert",
        "noDeliveryAddress": "Keine Lieferadresse",
        "noCommodity": "Ohne Sparte am Ziel kann die Produkt-API nicht gefragt werden.",
        "timeout": "Die Produkt-API hat nicht innerhalb von 10 Sekunden geantwortet.",
        "error": "Die Produkt-API hat mit Status {status} geantwortet: {message}",
        "errorWithoutStatus": "Die Anfrage an die Produkt-API ist fehlgeschlagen: {message}",
        "unreadable": "Die Antwort der Produkt-API ist nicht lesbar: {message}",
        "responseBody": "Antwort wie empfangen"
      },
      "errors": {
        "targets": "Die Ziele konnten nicht geladen werden.",
        "compare": "Der Vergleich konnte nicht durchgeführt werden."
      }
    }
  }
}
